import { render } from "./AddToFavButton.vue?vue&type=template&id=644daced"
import script from "./AddToFavButton.vue?vue&type=script&lang=js"
export * from "./AddToFavButton.vue?vue&type=script&lang=js"

import "./AddToFavButton.vue?vue&type=style&index=0&id=644daced&lang=scss"

import exportComponent from "/Users/vklosovych/Desktop/vue-exam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__